/**
 * Custom hook for checking if any message is currently being sent
 * This provides a unified way to check loading state across the app
 * Uses TanStack Query's mutation cache to check for active message mutations
 */

import { useIsMutating } from '@tanstack/react-query';
import { conversationQueryKeys } from '../api/conversations';

/**
 * Hook to check if any message is currently being sent
 * Returns true if there are any active chat mutations in progress
 */
export function useIsMessageSending(): boolean {
  // Only consider chat-send mutations (tagged via meta: { type: 'chat' })
  const totalActiveMutations = useIsMutating({
    predicate: (mutation) => (mutation.options as any)?.meta?.type === 'chat',
  });
  return totalActiveMutations > 0;
}

/**
 * Hook to check if a specific conversation has an active message being sent
 * More specific than useIsMessageSending - only checks for the given conversation
 */
export function useIsConversationSending(conversationId: string): boolean {
  // For now, this is the same as the general check
  // Could be enhanced later to be more specific to conversation ID
  return useIsMessageSending();
}
